import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminPanelPatient from 'components/templates/admin/panel/users';

const AdminPatients = () => {
  const filters = useSelector((state) => state.adminPanelUsers.filters);

  const {
    adminPanelUsers: { getUsers, getRoles },
  } = useDispatch();

  useEffect(() => {
    getRoles({});
  }, []);

  useEffect(() => {
    getUsers({});
  }, [filters]);

  return (
    <Container>
      <AdminHeader />
      <AdminPanelPatient />
    </Container>
  );
};

export default AdminPatients;
